import InputField from "../InputField/InputField";
import "../../pages/ProfileSettings/SetupProfile.css";
import pic from "../../pages/ProfileSettings/Logo.jpg";
import Button from "@mui/material/Button";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { SkillsArray, GenresArray } from "../../components/constants";
import { SelectField, useStyles } from "../../pages/ProfileSettings/styles";
import { submitButtonStyle } from "../../pages/ProfileSettings/styles";
import { setupProfileStyles } from "../../pages/ProfileSettings/styles";
import { Box, IconButton } from "@mui/material";
import { LightTooltip } from "../../components/LightToolTip/LightToolTip";
import MetaMaskSetup from "../../pages/MetaMaskSetup/MetaMaskSetup";
import { useAuth0 } from "@auth0/auth0-react";
import { SetupProfileSettingsProps } from "./types";
import { useGetCustomerPortalLink } from "../../hooks/useGetCustomerPortalLink";
import { styles } from "./styles";
import { FONT_FAMILY, TEXT_COLOR } from "../../theme";
import { formatFileSize } from "../../services/trackService";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const SetupProfileSettings: React.FC<SetupProfileSettingsProps> = ({
  setSelectedPanel,
  selectedPanel,
  errorFirstName,
  profile,
  handleChange,
  setErrorFirstName,
  errorFirstNameEmpty,
  errorLastName,
  setErrorLastName,
  errorLastNameEmpty,
  usedStorage,
  skillList,
  handleChangeSkill,
  genreList,
  handleChangeGenre,
  profilePic,
  onImageClick,
  profilePicture,
  onInputChange,
  handleSubmit,
}) => {
  const { isAuthenticated, user } = useAuth0();
  const classes = useStyles();
  const { getCustomerPortalLink } = useGetCustomerPortalLink();

  return (
    <>
      <div className="container">
        <h1 className="settings-header">Settings</h1>
        <Box sx={styles.walletContainer}>
          <Button
            onClick={() => setSelectedPanel("General")}
            sx={
              selectedPanel === "General"
                ? setupProfileStyles.panelButtonsActive
                : {
                    ...setupProfileStyles.panelButtonsDeactive,
                    ...{ color: TEXT_COLOR },
                  }
            }
          >
            General
          </Button>
          <Button
            onClick={() => setSelectedPanel("Ethereum Wallet")}
            sx={
              selectedPanel === "Ethereum Wallet"
                ? setupProfileStyles.panelButtonsActive
                : {
                    ...setupProfileStyles.panelButtonsDeactive,
                    ...{ color: TEXT_COLOR },
                  }
            }
          >
            Ethereum Wallet
          </Button>
          <Button
            onClick={() => setSelectedPanel("payment")}
            sx={
              selectedPanel === "payment"
                ? setupProfileStyles.panelButtonsActive
                : {
                    ...setupProfileStyles.panelButtonsDeactive,
                    ...{ color: TEXT_COLOR },
                  }
            }
          >
            Payment
          </Button>
        </Box>
        {selectedPanel === "General" && (
          <>
            <div className="form-body-settings">
              <div className="row-one">
                <InputField
                  error={errorFirstName && true}
                  label="first Name"
                  placeholder="First Name"
                  value={profile.firstName}
                  onchange={handleChange}
                  type="text"
                  onFocus={() => setErrorFirstName(false)}
                  isEmpty={errorFirstNameEmpty}
                />
                <InputField
                  error={errorLastName && true}
                  label="last Name"
                  placeholder="Last Name"
                  value={profile.lastName}
                  onchange={handleChange}
                  type="text"
                  onFocus={() => setErrorLastName(false)}
                  isEmpty={errorLastNameEmpty}
                />
                <InputField
                  value={profile.username}
                  label="username (stage name)"
                  onchange={handleChange}
                  type="text"
                  disabled={true}
                />
                <InputField
                  label="email"
                  value={isAuthenticated ? user?.email ?? "" : "Email"}
                  onchange={handleChange}
                  type="email"
                  disabled={true}
                />
              </div>

              <div className="row-one">
                <label htmlFor="bio" className="label__input">
                  Bio
                  <LightTooltip
                    title="Emails and URLs will be extracted and linked"
                    enterTouchDelay={0}
                    enterDelay={300}
                  >
                    <IconButton disableRipple>
                      <HelpOutlineIcon
                        color="info"
                        style={{ height: 16, width: 16 }}
                      />
                    </IconButton>
                  </LightTooltip>
                </label>
                <TextField
                  inputProps={{ style: { fontFamily: "Argumentum" } }}
                  multiline
                  rows={5}
                  variant="outlined"
                  name="bio"
                  id="bio"
                  value={profile.bio}
                  className="bio_input"
                  onChange={handleChange}
                  sx={styles.textArea}
                ></TextField>
              </div>
              <div className="row-one">
                <InputField
                  label="wallet"
                  value={
                    profile.connectedWallet
                      ? profile.connectedWallet
                      : "Wallet Address"
                  }
                  onchange={handleChange}
                  type="text"
                  disabled={profile.connectedWallet ? true : false}
                />
              </div>
              <div className="row-one">
                <InputField
                  label="Total storage used"
                  value={`${formatFileSize(usedStorage)}`}
                  type="text"
                  onchange={() => {}}
                  disabled={true}
                />
              </div>
              {process.env.REACT_APP_ENV === "dev" && (
                <div className="row-one">
                  <InputField
                    label="Subscription tier"
                    value={"Free"}
                    onchange={() => {}}
                    type="text"
                    disabled={true}
                  />
                </div>
              )}
              <div className="row-one">
                <label htmlFor="bio" className="label__input">
                  Skills
                </label>

                <Stack spacing={3}>
                  <SelectField
                    multiple
                    style={{ width: "92%" }}
                    id="checkboxes-tags-demo"
                    options={SkillsArray}
                    disableCloseOnSelect
                    value={skillList}
                    onChange={handleChangeSkill}
                    renderOption={(props, option, { selected }) => (
                      <li {...props} style={{ fontFamily: FONT_FAMILY }}>
                        <>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option}
                        </>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label=" "
                        InputLabelProps={{ shrink: false }}
                        classes={{ root: classes.customTextField }}
                      />
                    )}
                  />
                </Stack>
              </div>

              <div className="row-one">
                <label htmlFor="bio" className="label__input">
                  Genres
                </label>

                <Stack spacing={3}>
                  <SelectField
                    multiple
                    style={{ width: "92%" }}
                    id="checkboxes-tags-demo"
                    options={GenresArray}
                    disableCloseOnSelect
                    value={genreList}
                    onChange={(e, v) => handleChangeGenre(e, v)}
                    renderOption={(props, option, { selected }) => (
                      <li {...props} style={{ fontFamily: FONT_FAMILY }}>
                        <>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option}
                        </>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label=" "
                        InputLabelProps={{ shrink: false }}
                        classes={{ root: classes.customTextField }}
                      />
                    )}
                  />
                </Stack>
              </div>

              <div className="row-one">
                <label
                  style={{ color: TEXT_COLOR }}
                  htmlFor={"image"}
                  className="label__input"
                >
                  Profile Picture
                </label>

                <div className="profile-pic">
                  <img
                    src={profilePic ? profilePic : pic}
                    alt="profilepic"
                    className="profile-image"
                    onClick={onImageClick}
                  />
                </div>
                <input
                  type="file"
                  id={"image"}
                  name={"profilePic"}
                  className="input__file"
                  ref={profilePicture}
                  accept="image/*"
                  multiple={false}
                  style={{ display: "none" }}
                  onChange={onInputChange}
                />
                <p style={{ color: TEXT_COLOR }} className="prof-img-sub">
                  Click the image to upload
                </p>
              </div>

              <div className="btn-center">
                <Button
                  onClick={handleSubmit}
                  sx={submitButtonStyle}
                  size="large"
                  variant="contained"
                >
                  Save changes
                </Button>
              </div>
            </div>
          </>
        )}
        {selectedPanel === "Ethereum Wallet" && (
          <>
            <MetaMaskSetup />
          </>
        )}
        {selectedPanel === "payment" && (
          <Box sx={{ height: "35vh" }}>
            <Button
              onClick={getCustomerPortalLink}
              sx={styles.goToBillingPortalButton}
            >
              Go To Billing Portal
            </Button>
          </Box>
        )}
      </div>
    </>
  );
};
